export default __webpack_public_path__ + "static/media/alert.276d6f99.svg";